import { all, takeLatest, call, put } from "redux-saga/effects";
import {
  fetchBusinessMenu,
  fetchPersonalMenu,
  fetchAboutUsMenu,
  fetchCustomerSupportMenu,
  fetchFooterSitemap,
} from "network/services/navigationServices";
import {
  fetchNavigatorDataFailed,
  fetchNavigatorDataSuccess,
} from "../actionCreators";
import type { ISaga, NavigatorDataData } from "../types";
import { arrangeArrayOfStringAlphabetically } from "utils/helpers";

function* fetchNavigationData(): ISaga {
  try {
    const [
      personal_main_menu,
      business_main_menu,
      about_us,
      customer_support,
      footer_sitemap,
    ] = yield all([
      call(fetchPersonalMenu),
      call(fetchBusinessMenu),
      call(fetchAboutUsMenu),
      call(fetchCustomerSupportMenu),
      call(fetchFooterSitemap),
    ]);

    const business_menu = arrangeArrayOfStringAlphabetically(
      business_main_menu.data,
      "title"
    ).map(({ below }) => below);
    const personal_menu = arrangeArrayOfStringAlphabetically(
      personal_main_menu.data,
      "title"
    ).map(({ below }) => below);

    const payload: NavigatorDataData = {
      business_main_menu: business_menu,
      personal_main_menu: personal_menu,
      about_us: about_us.data,
      customer_support: customer_support.data,
      footer_sitemap: footer_sitemap.data,
    };

    yield put(fetchNavigatorDataSuccess(payload));
  } catch (e) {
    yield put(fetchNavigatorDataFailed());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_NAVIGATOR_DATA", fetchNavigationData);
}
